import { QueryState } from 'src/app/core/models/query.model';
import { createTokenQueryServiceInstance } from 'src/app/core/services/query.service';
import { SignalStoreConfig } from 'src/app/shared/functions/store.functions';
import { ITableColumn } from 'src/app/core/models/table.model';
import { IElaborazione } from './models/elaborazione.model';

export const ELABORAZIONI_ENDPOINT = 'elaborazione-all';
export const ELABORAZIONE_ENDPOINT = 'elaborazione';
export const ELABORAZIONI_ENDPOINT_QUERY_SERVICE_INSTANCE = createTokenQueryServiceInstance(ELABORAZIONI_ENDPOINT);

export const elaborazioneStateConfig: SignalStoreConfig<QueryState<IElaborazione>> = {
    initState: {
        list: [],
      }
}

export const ELABORAZIONI_COLUMNS: ITableColumn[] = [
    {
        name: 'idElaborazione',
        label: 'ID elaborazione',
        field: 'idElaborazione',
        primaryKey: true
    },
/*     {
        name: 'nomeFile',
        label: 'Nome file',
        field: 'nomeFile'
    }, */
    {
        name: 'idUtente',
        label: 'ID utente',
        field: 'idUtente'
    },
    {
        name: 'type',
        label: 'Tipo file',
        field: 'type'
    },
    {
        name: 'content',
        label: 'contenuto',
        field: 'content'
    },
    {
        name: 'createdAt',
        label: 'Data e ora Elaborazione',
        field: 'createdAt',
        type: 'datetime',
      },
    {
        name: 'statoElaborazione',
        label: 'Stato elaborazione',
        field: 'statoElaborazione'
    },
    {
        name: 'erroreElaborazione',
        label: 'Errore elaborazione',
        field: 'erroreElaborazione'
    },
    {
        name: 'note',
        label: 'Note',
        field: 'note'
    }
];

export const ELABORAZIONI_VISIBLECOLUMNS = [
    'idElaborazione',
    //'nomeFile',
    'idUtente',
    'type',
    'content',
    'createdAt',
    'statoElaborazione',
    'erroreElaborazione',
    'note'
];
